module.exports = __webpack_public_path__ + "static/2front-spirit-3-aff8ff4767d4100417386d8b50b53447.png";